import React from 'react';
import { Bubble, CardLabel, FunButton, FunCard } from './GameUI';

const CODE_LENGTH = 4;

class JoinGame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: String(props.initialCode || '').toUpperCase().slice(0, CODE_LENGTH),
      localError: '',
    };
  }

  onChange = (event) => {
    this.setState({
      localError: '',
      code: event.target.value.toUpperCase().replace(/\s/g, '').slice(0, CODE_LENGTH),
    });
  };

  onSubmit = (event) => {
    if (event) event.preventDefault();
    if (this.state.code.length !== CODE_LENGTH) {
      this.setState({ localError: `Game codes are ${CODE_LENGTH} characters.` });
      return;
    }
    this.props.onJoin(this.state.code);
  };

  render() {
    const featured = this.props.featured === true;
    const error = this.state.localError || this.props.error;
    return (
      <FunCard entranceIndex={featured ? 1 : 4}>
        {!featured && (
          <div>
            <CardLabel emoji="🔑" text="Have a code?" className="gpJoin__label" />
            <p className="gpSubtitle">Enter your partner's game code to join their game.</p>
          </div>
        )}

        <form onSubmit={this.onSubmit}>
          <div className="gpTicket">
            <span className="gpTicket__notch gpTicket__notch--left" aria-hidden="true" />
            <span className="gpTicket__notch gpTicket__notch--right" aria-hidden="true" />
            <input
              className="gpTicket__input"
              value={this.state.code}
              onChange={this.onChange}
              maxLength={CODE_LENGTH}
              placeholder="AB12"
              autoCapitalize="characters"
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              aria-label="Game code"
            />
          </div>

          {!!error && <Bubble emoji="🙈" text={error} />}

          <FunButton
            variant="sunny"
            emoji="🎟️"
            text="Join game"
            loading={this.props.busy}
            onClick={this.onSubmit}
          />
        </form>
      </FunCard>
    );
  }
}

export default JoinGame;
